/**
 * Store: Size guide store
 * -----------------------------------------------------------------------------
 * Store to hold the product type used by the global size guide drawer.
 */
export default {
  namespaced: true,

  state: () => ({
    type: '',
  }),

  mutations: {
    /**
     * Set product type to look the size guide up with.
     * @param {String} type - Product type, or size guide collection handle.
     */
    SET_TYPE(state, type) {
      state.type = type
    },
  },

  actions: {
    /**
     * Commit product type used by the global size guide drawer.
     * @param {String} type - Product type, or size guide collection handle.
     */
    setType({ commit }, type) {
      commit('SET_TYPE', type)
    },
  },
}
